import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild, ElementRef } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-generic-search',
  templateUrl: './generic-search.component.html',
  styleUrls: ['./generic-search.component.scss']
})
export class GenericSearchComponent implements OnInit, OnChanges {
  @Input() testingId = null;
  @Input() searchString: string;
  @Input() focus = false;
  @Input() label: string;
  @Input() placeholder = '';
  @Input() minimumLength = 3;
  @Input() debounce = 200;
  @Input() loading = false;
  @Input() hint: string;

  @Output() search = new EventEmitter<string>();
  @Output() clearSearch = new EventEmitter<null>();

  @ViewChild('search', { static: true }) searchField: ElementRef;

  searchForm = new UntypedFormControl('');

  constructor() {}

  ngOnInit() {
    if (this.focus) {
      this.searchField.nativeElement.focus();
    }
    this.searchForm.valueChanges
      .pipe(debounceTime(this.debounce))
      .subscribe(value => (value?.length >= this.minimumLength ? this.search.emit(value) : null));

    if (this.testingId === null) {
      this.testingId = this.label;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['searchString'] && changes['searchString'].currentValue !== this.searchForm.value) {
      this.searchForm.setValue(changes['searchString'].currentValue);
    }
  }
}
